const HIGHLIGHT_MARKER = '**';

export interface IFormattedTextPart {
  text: string;
  highlight: boolean;
}

export default function splitFormattedText(
  text?: string | null,
): IFormattedTextPart[] {
  if (!text) return [];

  const parts = text.split(HIGHLIGHT_MARKER);

  return parts
    .map((part, index) => ({
      text: part,
      highlight: index % 2 === 1 && index < parts.length - 1,
    }))
    .filter(part => part.text.length > 0);
}
